//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            searchText: "",
            nav: "1",
            isPrice: false,
            isFenlei: true
        }
    },
    methods: {
        goHome() { // input 回车搜索
            this.$router.push({
                name: 'home'
            });
        },
        onSubmit() { // input 回车搜索
            this.$store.commit('updateKeyWorld', this.searchText);
        },
        filterTap(index, type) {
            this.nav = index;
            if (index == 3) {
                this.isPrice = !this.isPrice;
                let r_sort = !this.isPrice ? 'price desc' : 'price asc';
                this.$store.commit('updateFilter', r_sort);
            } else {
                this.isPrice = false;
                this.$store.commit('updateFilter', type);
            };
        },
        toggle() {
            this.isFenlei = !this.isFenlei
            this.$store.commit('updateTemplate', this.isFenlei);
        }
    },
    computed: {},
    created() {
        this.searchText = this.$route.params.keyworld;
    }
}



// WEBPACK FOOTER //
// ./src/components/Search/header.vue